/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {FC, useEffect, useMemo, useState} from 'react'
import {TabCentralModel} from '../../../../../../models'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {useCentral} from '../../../../../../hooks/useCentral'
import {getParamsTable, getCategory, getDataType, getMasterService} from '../../../../services'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {ParamsModel, CategoryModel, MasterModel} from '../../../../model'
const TableParam: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    clearSelected,
    pagination,
    updateTable,
    setUpdateTable,
    selectedOn,
    clearTable,
    setClearTable,
  } = useKTable()
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useCentral()
  const {searchValues, clearSearchValues, changeSearchValues} = useKhipu()
  const [category, setCategory] = useState<MasterModel[] | any>([])
  const [params, setParams] = useState<MasterModel[] | any>([])
  const [dataType, setDataType] = useState<MasterModel[] | any>([])
  const [status, setStatus] = useState<MasterModel[] | any>([])

  const getParamsList = async () => {
    try {
      setLoading(true)
      const {data: response} = await getParamsTable(searchValues, pagination.currentPage)
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    getCategoryList()
    getParamsList()
    getDataTypeList()
    getStatusList()
    return () => {
      clearSearchValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    if (Object.keys(searchValues).length === 0) {
      getParamsList()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValues])
  useEffect(() => {
    getParamsList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])
  const getCategoryList = async () => {
    let obj: CategoryModel = {
      isCombo: true,
    }
    const response = await getCategory(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.codigo, label: item.codigo}))
    setCategory(mappedSites)
  }
  const getParamsListSelect = async (tableName: string) => {
    let obj: ParamsModel = {
      isCombo: true,
    }
    const response = await getParamsTable(obj, 1, tableName)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.codigo, label: item.nombreCorto}))
    setParams(mappedSites)
  }
  const getDataTypeList = async () => {
    try {
      const response = await getDataType()
      const data = response.data.data
      const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
      setDataType(mappedSites)
    } catch (error) {
      console.error('Error al obtener la lista de países:', error)
    }
  }
  const handleViewPanel = (data: any) => {
    const getRow = data.row
    const getArrows = data.data
    const getData = getArrows[getRow.index]
    const obj: TabCentralModel = {
      ...currentTabItem,
      showPanel: true,
      content: {
        ...currentTabItem.content,
        detailPanel: 'form-params',
      },
      idToEdit: getData.id,
      idToDelete: '',
    }
    changeCurrentTabItem(obj)
    clearSelected()
  }

  const getStatusList = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'EstadoMaestro',
      })
      const data = response.data.data
      const mappedMaster = data.map((master: any) => ({
        value: master.codigo,
        label: master.nombreCorto,
        codigo: master.codigo,
      }))
      setStatus(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de estado del maestro:', error)
    }
  }

  const handleGetId = (id: any) => {
    let idChange = id === currentTabItem.idToDelete ? '' : id
    const obj: TabCentralModel = {
      ...currentTabItem,
      showPanel: false,
      idToDelete: idChange,
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
  }
  const handleFilterParams = (e: any, name: string) => {
    let value = e.value
    getParamsListSelect(value)
    const {...valuesSearch} = searchValues
    const nuevoObjeto = {...valuesSearch, [name]: value}
    changeSearchValues(nuevoObjeto)
  }
  const columns: Column<ParamsModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} showSelect={false} />,
        id: 'selection',
        Cell: ({...props}) => (
          <KTableSelectionCellNonMultiple
            id={props.data[props.row.index].id}
            clickHandler={handleGetId}
          />
        ),
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Categoría'
            name='tabla'
            data={category}
            selecteable
          />
        ),
        accessor: 'tabla',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Código' name='codigo' searcheable />
        ),
        accessor: 'codigo',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Nombre Corto' name='nombreCorto' searcheable />
        ),
        accessor: 'nombreCorto',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Nombre Largo' name='nombreLargo' searcheable />
        ),
        accessor: 'nombreLargo',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo de dato'
            name='tipoDato'
            data={dataType}
            selecteable
          />
        ),
        accessor: 'tipoDato',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Estado' name='estado' data={status} selecteable />
        ),
        accessor: 'estado',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Categoría Padre'
            name='tablaPadre'
            data={category}
            selecteable
            onGetValueSelect={handleFilterParams}
          />
        ),
        accessor: 'tablaPadre',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Código Padre'
            name='codigoPadre'
            data={params}
            selecteable
          />
        ),
        accessor: 'codigoPadre',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions',
        Cell: ({...props}) => (
          <>
            {isAllowed('EDITAR') && (
              <div
                className='d-flex justify-content-center flex-shrink-0'
                onClick={() => handleViewPanel(props)}
              >
                <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                  <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
                </a>
              </div>
            )}
          </>
        ),
      },
    ],
    [selectedOn, category, params, status, dataType],
  )

  useEffect(() => {
    setInitialPagination()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.loadingTable])

  const setInitialPagination = async () => {
    const {data: response} = await getParamsTable({}, pagination.currentPage)
    setPagination({
      perPage: 10,
      currentPage: 1,
      totalResults: response.total,
    })
  }

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  useEffect(() => {}, [data])

  useEffect(() => {
    if (currentTabItem.loadingTable) {
      clearSelected()
      getParamsList()
      changeCurrentTabItem({...currentTabItem, loadingTable: false})
    }
  }, [currentTabItem.loadingTable])
  useEffect(() => {
    if (updateTable) {
      clearSelected()
      getParamsList()
      setUpdateTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTable])
  useEffect(() => {
    if (clearTable) {
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])
  return (
    <>
      <KTCard shadow className='mx-2  w-100'>
        <KTable data={data} columns={columns} classNameProps='dataTablecentral' />
        {loading ? <KTableLoading title='Cargando...' /> : null}
      </KTCard>
    </>
  )
}

const TableParamWrapper = () => {
  return (
    <KTableProvider>
      <TableParam />
    </KTableProvider>
  )
}

export {TableParamWrapper}
